import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { ConfirmationService, Message, MessageService } from "primeng/api";
import { data_fields, data_item } from "src/app/misc/interface/data";
import { DataService } from "src/app/services/data.service";
import { GlobalConstants } from "src/app/services/global-constants";
import { OrgUnitsService } from "src/app/services/org-units.service";
import { PermissionHandlerService } from "src/app/services/permission-handler.service";
import { TemplateFieldsService } from "src/app/services/templete-fileds.service";
import { MenuItem } from "src/app/misc/interface/menu-item";

import { TranslatorPipe } from "src/app/services/translator.pipe";
import { cloneDeep } from "lodash";

@Component({
  selector: "app-select-service",
  templateUrl: "./select-service.component.html",
  styleUrls: ["./select-service.component.scss"],
})
export class SelectServiceComponent {
filterFunctionByPostOuFilter($event: any) {
  this.ouFilter = $event.node;
}
  //filters
  ouTypes: any;
  typeFilter: any = undefined;
  ouFilter: any = undefined;
  serchFilter: string = "";
  treeData: any[] = [];
  data: any;
  filteredData: any;
  translator: TranslatorPipe = new TranslatorPipe();
  firstSearch: boolean = true;

  apilink = GlobalConstants.apiURL;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  skelition: boolean = false;
  loadingFilters: boolean = true;
  data_types: any;
  currentTypeFilter: any;

  fieldTypes: any;
  messages: Message[] = [];

  @Output() currentDataItem: EventEmitter<data_item> = new EventEmitter();

  constructor(
    private dataService: DataService,
    // private confirmationService: ConfirmationService,
    // private messageService: MessageService,
    private ouService: OrgUnitsService,
    public permissionService: PermissionHandlerService,
    private templateService: TemplateFieldsService,
  ) { }

  //Get tree data and as per the  permission
  // async getTreeData() {
  //   this.treeData = await this.permissionService.extractOUChildren('BULK_EDIT', 'a');
  // }

  resetFilters() {
    this.serchFilter = "";
    this.ouFilter = undefined;
    this.typeFilter = undefined;
  }

  //Getting Initial Data in bulk
  getData = async () => {
    try {
      this.skelition = true;
      this.firstSearch = false;
      console.log("Test = rs 000 99");

      let searchTerm = this.serchFilter;
      let ouId = this.ouFilter?.id;

      if (!searchTerm) {
        searchTerm = "all";
      }

      let url = `data/textSearch?text=${searchTerm}`;
      if (ouId) {
        url += `&ou=${ouId}`;
      }
      let res = await this.dataService.postData(url, { ous: this.permissionService.content });

      // let res = await this.dataService.getData('data/data-view');

      if (res.error) return;

      console.log("this.treeData", this.treeData);

      if (this.treeData.length > 0) {
        this.data = res.data.filter((e: any) =>
          this.ouService.childrenContainsId(this.treeData, e.ous),
        );
      } else {
        this.data = res.data.filter(
          (item: any) => item.type.name !== "Licence",
        );
      }

      this.filteredData = this.data;

      this.filteredData = this.data.filter(
        (item: any) => item.type.name !== "Licence",
      );

      this.first = 0;
      this.rows = 10;
      this.totalRecords = this.filteredData.length;
      this.setupTypes();
      console.log("data get ==,,,", this.filteredData);
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  ngOnInit() {
    Promise.all([
      this.fetchFieldType(),
      this.getOuType(),
      this.getTreeData(),
    ]).then((e) => {
      this.loadingFilters = false;
    });
  }

  setupTypes() {
    let mymap = new Map();

    var unique = this.data.filter((el: any) => {
      const item = el.type;
      if (item) {
        const val = mymap.get(item?.name);
        if (val) {
          if (item && item._id && item._id < val) {
            mymap.delete(item.name);
            mymap.set(item.name, item._id);
            return true;
          } else {
            return false;
          }
        }
        mymap.set(item.name, item._id);
        return true;
      } else {
        return false;
      }
    });

    var uniquetypes: any[] = [];
    if (unique.length > 0) {
      unique.forEach((item: any) => {
        uniquetypes.push(item.type);
      });
    }

    this.data_types = uniquetypes;

    // console.log('data types', this.data_types);
  }

  counter(countertype: string) {
    return this.data.filter((val: any) => {
      if (val.type?.name == countertype) {
        return true;
      } else {
        return false;
      }
    }).length;
  }

  applyTypeFilter(value: any) {
    this.currentview = null;
    this.changeView(this.currentview);

    if (this.currentTypeFilter != value) {
      this.currentTypeFilter = value;
    } else {
      this.currentTypeFilter = "all";
    }

    // console.log(value);
    if (this.currentTypeFilter == "all") {
      this.dataView.filter("", "contains");
    } else {
      this.dataView.filter(value, "equals");
    }
    this.updateTotalCount();
  }

  updateTotalCount() {
    this.totalRecords = this.dataView.totalRecords;
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData(
      "field-type/get?offset=1000&page=1",
      {
        active: true,
      },
    );
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data;
  }
  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  //Get Ou types
  getOuType = async () => {
    try {
      let res = await this.dataService.postData(
        "data-type/get?offset=1000&page=1",
        {
          active: true,
        },
      );
      if (res.error) {
        this.messages = [
          {
            severity: "error",
            summary: this.translate("error"),
            detail: res.msg,
          },
        ];
        return;
      }
      this.ouTypes = res.data.map((item: any) => {
        return {
          label: item.arabic,
          value: item._id,
          icon: item.icon,
        };
      });
    } catch (error) {
      console.log(error);
    }
  };

  //Service filter function
  filterFunction() {
    this.filteredData = this.data;

    if (this.typeFilter) {
      this.filteredData = this.filterData(this.data, "_id", this.typeFilter);
    }

    if (this.ouFilter) {
      this.filteredData = this.filterData(
        this.filteredData,
        "id",
        this.ouFilter.id,
      );
    }

    this.filteredData = this.filteredData.filter((obj: any) => {
      return Object.keys(obj).length >= 8;
    });

    this.first = 0;
    this.rows = 10;
    this.totalRecords = this.filteredData.length;

    //Updating  the count
    // this.updateTypeCounts();
  }

  //Function to get common fields of the selected data
  filterData(data: any, key: any, value: any) {
    let results: any = [];

    //Base Recursive Function
    function recursiveFilter(obj: any, parentObj = null) {
      if (Array.isArray(obj)) {
        obj.forEach((item) => recursiveFilter(item, parentObj));
      } else if (typeof obj === "object") {
        if (obj != null && obj.hasOwnProperty(key) && obj[key] === value) {
          if (parentObj) {
            results.push(parentObj);
          }
          results.push(obj);
        }
        if (obj != null && obj != undefined)
          Object.values(obj).forEach((value) => recursiveFilter(value, obj));
      }
    }

    recursiveFilter(data);
    return results;
  }
  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  currentview: any = null;

  editIndex = -1;

  //Get type of the filed
  getFieldType(type: any) {
    if (type._id) {
      type = type._id;
    }

    if (this.fieldTypes == undefined) {
      this.fetchFieldType().then(() => {
        var result = this.fieldTypes.find(
          (item: any) => item._id == type,
        )?.name;
        return result;
      });
    } else {
      var result = this.fieldTypes.find((item: any) => item._id == type)?.name;
      return result;
    }

    // console.log("===>Filed type : ", type);

    // console.log("====> types to match", this.fieldTypes)

    // return this.fieldTypes.find((item: any) => item._id == type)?.name
  }
  currentPage: number = 1;
  totalPages: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  sortOrder: number = 1;
  rows: number = 10;
  sortField: string = "";
  pages: any[] = [];
  @ViewChild("dv") dataView!: DataView | any;

  goToPage(maxPage: number) {
    // Validate input and navigate to the specified page

    console.log(
      maxPage,
      this.currentPage,
      this.currentPage >= 1 && this.currentPage <= maxPage,
    );
    if (this.currentPage >= 1 && this.currentPage <= maxPage) {
      this.dataView.paginate({
        first: (this.currentPage - 1) * this.dataView.rows,
        rows: this.dataView.rows,
      });
    }
  }
  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.resetDataview();
    this.dataView.filter($event.target.value, stringVal);
    this.updateTotalRecords();
  }

  resetDataview() {
    this.currentview = {
      id: 0,
      name: "يرجى اختيار البيانات",
      breadcrumbs: [],
    };
  }
  updateTotalRecords() {
    if (this.dataView) {
      this.totalRecords = this.dataView.totalRecords;
    }
  }

  changeToNumber(arg0: string): number {
    return Number(arg0);
  }
  changePage(n: number) {
    const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
    if (n > 0 && n <= maxPage) {
      console.log(n, this.currentPage, maxPage);
      this.currentPage = n;
      this.goToPage(n);
    }
  }

  moveToLast(reverse: boolean) {
    if (reverse) {
      this.first = 0;
      this.rows = this.dataView.rows;
      this.currentPage = 1;
      this.dataView.paginate({ first: this.first, rows: this.rows });
    } else {
      const maxPage = Math.ceil(this.totalRecords / this.dataView.rows);
      this.first = (maxPage - 1) * this.dataView.rows;
      this.rows = this.dataView.rows;
      this.currentPage = maxPage;
      this.dataView.paginate({
        first: this.first,
        rows: this.rows,
      });
    }
  }

  async changeView(_t29: any) {
    // _t29;
    // console.log('SORTING', _t29)
    // _t29.fields?.sort((a: data_fields, b: data_fields) => {
    //   if (a.label?.priority && b.label?.priority) {
    //     return a.label?.priority - b.label?.priority;
    //   } else {
    //     return 0;
    //   }
    // });

    // _t29.breadcrumbs.sort((a: any, b: any) => {
    //   return b.depth - a.depth;
    // });
    console.log("SORTING AFTER", _t29);
    _t29.breadcrumbs.forEach((item: MenuItem) => {
      console.log("ITEM BREAD", item);
      item.routerLink = "/category/" + item.id;
      if (this.checkisImg(item.icon)) {
        item.image = item.icon;
      }
    });

    this.currentview = _t29;

    this.currentview = await this.getOne();

    this.currentview.fields?.sort((a: data_fields, b: data_fields) => {
      if (a.label?.priority && b.label?.priority) {
        return a.label?.priority - b.label?.priority;
      } else {
        return 0;
      }
    });

    this.currentview.breadcrumbs.sort((a: any, b: any) => {
      return b.depth - a.depth;
    });

    this.currentview = {
      ...this.currentview,
      fields:
        this.currentview?.fields?.map((item: any) => {
          return { ...item, isChecked: false };
        }) || [],
    };

    this.currentview.fields = await this.templateService.fetchTemplateFields(
      this.currentview,
    );
    //this.justinCase();
  }

  async getOne() {
    try {
      let res = await this.dataService.getData(
        "data/one/" + this.currentview.id,
      );
      if (res.error) {
        return;
      }
      return res.data[0];
    } catch (e) {
      console.log(e);
    }
  }

  //additional section process
  sendData() {
    console.log("currect Data Item : ", this.currentview);
    this.currentDataItem.emit(this.currentview);
  }

  //tree Data
  //Get tree data and as per the  permission
  async getTreeData() {
    this.treeData = await this.ouService.getLatesOrgs();

    console.log("treeData", this.treeData);

    this.selectedTreeData_orginal = cloneDeep(this.treeData);
    this.changeSelectedTag(null);
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      // if (node._id === nodeName) {
      //   return node;
      // }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      label: "Content Related",
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event, this.selectedTreeData);
      await this.filterTreeByTag("Content Related");
    } else {
      this.selectedTreeData = null;
    }
  }

  selectedTreeData: any = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  filterTreeByTag(tag: string) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = [];
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: [],
        });
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);

      console.log(
        "cloneitems.children this.selectedTreeData",
        this.selectedTreeData,
      );
    }
  }

  filterNodes(node: any, tag: string): any | null {
    // Recursively filter children nodes
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }
}
